import api from './api';

export interface ExecutiveMessage {
  id: string;
  type: 'CHAIRMAN' | 'MD';
  content: string;
  profilePicture?: string;
  updatedBy?: {
    id: string;
    fullName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export const messagesService = {
  async getAll(): Promise<ExecutiveMessage[]> {
    const response = await api.get('/messages');
    return response.data;
  },

  async getByType(type: 'CHAIRMAN' | 'MD'): Promise<ExecutiveMessage | null> {
    const response = await api.get(`/messages/${type}`);
    return response.data;
  },

  async update(type: 'CHAIRMAN' | 'MD', content: string): Promise<ExecutiveMessage> {
    const response = await api.put(`/messages/${type}`, { content });
    return response.data;
  },

  async uploadProfilePicture(type: 'CHAIRMAN' | 'MD', file: File): Promise<ExecutiveMessage> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/messages/${type}/profile-picture`, formData);
    return response.data;
  },
};
